import { render, staticRenderFns } from "./helpDocuments.vue?vue&type=template&id=5bb149df&scoped=true&"
import script from "./helpDocuments.vue?vue&type=script&lang=js&"
export * from "./helpDocuments.vue?vue&type=script&lang=js&"
import style0 from "./helpDocuments.vue?vue&type=style&index=0&id=5bb149df&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bb149df",
  null
  
)

export default component.exports